import React, { useState } from 'react';
import ChatComponent from './SectionScreens/ChatComponent';
import MapComponent from './SectionScreens/MapComponent';
import AnalysisSidebar from './SectionScreens/AnalysisSidebar';
import "./ModelUI.css"

function ModelUI() {
  const [state, setState] = useState({
    contraflow: false,
    blockedRoads: 0,
    time: 0,
    dynamic_data: [],
    mapDataText: null,
    generalMapLegendText:
      '- Red: High traffic (> 50% road queued)\n- Orange: Moderate traffic (25 - 50% road queued)\n- Green: Low traffic (<25% road queued)',
    selectedLinkIds: [],
    selectedNodeIds: [],
    maxTime: 5000,
    selectedSimulationId: 'simulation_1'
  });

  const [currentChatId, setCurrentChatId] = useState('a_0000');   // default chat
  const [chatPathIds, setChatPathIds] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false); 

  const updateState = upd => setState(p => ({ ...p, ...upd }));

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      minHeight: 0,
      overflow: 'hidden',
      background: '#1E1E1E',
      color: '#FFF'
    }}>

      {/* sidebar */}
      <AnalysisSidebar
        currentChatId={currentChatId}
        setCurrentChatId={setCurrentChatId}
        chatPathIds={chatPathIds}
        setChatPathIds={setChatPathIds}
        isOpen={sidebarOpen}
      />

    <button
      onClick={() => setSidebarOpen(!sidebarOpen)}
      style={{
        position: 'fixed',
        top: '10px',
        left: '10px',
        width: '30px',
        height:'30px',
        borderRadius: '20px',
        border: 'none',
        fontSize: '20px',
        background: '#007BFF',
        color: '#FFF',
        cursor: 'pointer',
        zIndex: 10020,    // above the sidebar
      }}
    >
      ☰
    </button>

      {/* main area */}
      <div style={{ flex: 1, minWidth: 0, minHeight: 0, padding: 20, boxSizing: 'border-box', overflow: 'hidden' }}>
        <div className="model-ui-container">
          <div className="chat-section">
            <ChatComponent
              state={state}
              updateState={updateState}
              chatId={currentChatId}        /* ← pass active chat id */
              chatPathIds={chatPathIds}
            />
          </div>
          <div className="map-section">
            <MapComponent state={state} updateState={updateState} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModelUI;
